import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#c89040",
      dark: "#b27d34",
      light: "#d9ab63",
      contrastText: "#000000",
    },
    background: {
      default: "rgba(0,0,0,0.75)",
      paper: "rgba(0,0,0,0.6)",
    },
    text: {
      primary: "#f0e6d0",
      secondary: "#a09070",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          backgroundColor: "#c89040",
          color: "#000000",
          fontWeight: 600,
          "&:hover": {
            backgroundColor: "#b27d34",
          },
        },
        outlinedPrimary: {
          borderColor: "#c89040",
          color: "#c89040",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          color: "#f0e6d0",
          "& fieldset": {
            borderColor: "rgba(200,144,64,0.18)",
          },
          "&:hover fieldset": {
            borderColor: "#c89040",
          },
          "&.Mui-focused fieldset": {
            borderColor: "#c89040",
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: "#a09070",
          "&.Mui-focused": {
            color: "#c89040",
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: "rgba(20,15,8,0.97)",
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          color: "#f0e6d0",
          "&:hover": {
            backgroundColor: "rgba(200,144,64,0.1)",
          },
          "&.Mui-selected": {
            backgroundColor: "rgba(200,144,64,0.18)",
          },
        },
      },
    },
  },
});

export default theme;
